export default {
  black: '#333333',
  red: '#bf0000',
  gray: '#9c9c9c',
  white: '#ffffff',
  text: {
    black: '#333333',
    darkGray: '#4d4d4d',
    gray: '#828282',
    green: '#047205',
    white: '#ffffff',
  },
  border: {
    blue: '#009ae9',
    darkGray: '#828282',
    gray: '#b6b6b6',
    lightGray: '#dadada',
    ultraLightGray: '#ebebeb',
    green: '#047205',
    yellowGreen: '#c9db00',
    lightGreen: '#7fca51',
    red: '#f53a3a',
    darkRed: '#bf0000',
    orange: '#f59600',
    yellow: '#ffd633',
  },
};



// WEBPACK FOOTER //
// ./src/components/SurveyToast/styles/constants/Color.js